mutation CreateLeadByThread($input: LeadCreateByThreadInput!) {
    leadCreateByThread(input: $input) {
        lead {
            id
            htmlUrlPath
        }
    }
}
